/*
 * @Author: ZhaoDong
 * @Date: 2022-09-26 09:47:13
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-09-26 09:50:40
 * @Description:  案例管理
 */
import request from '@/utils/request'

// 案例列表
export function casesList(data) {
  return request({
    url: '/cases/list',
    method: 'post',
    data
  })
}

// 案例添加
export function casesCreate(data) {
  return request({
    url: '/cases/create',
    method: 'post',
    data
  })
}

// 案例更新
export function casesUpdate(data) {
  return request({
    url: '/cases/update',
    method: 'post',
    data
  })
}

// 案例详情
export function casesDetail(data) {
  return request({
    url: '/cases/detail',
    method: 'post',
    data
  })
}

// 案例删除
export function casesDelete(data) {
  return request({
    url: '/cases/delete',
    method: 'post',
    data
  })
}

// 案例状态修改
export function casesUpdateStatus(data) {
  return request({
    url: '/cases/update-status',
    method: 'post',
    data
  })
}

// 案例相关模板字段
export function casesTemplateFields(data) {
  return request({
    url: '/cases/template-fields',
    method: 'post',
    data
  })
}
